export default __webpack_public_path__ + "static/media/loyalty.74857539.svg";